import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { PermissionsEnum } from 'src/app/models/role.model';
import { PermissionsService, SubstationTemplateService, UtilitySharedService } from 'shared-lib';
import { WorkOrderMenuItem } from 'src/app/models/workOrderMenuItem.model';
import { ReportStateService } from '../reports/services/report-state.service';
import { ReadingsMenuTab } from 'src/app/models/readingsMenuTab.model';
import { SidebarService } from 'src/app/services/sidebar.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  public PermissionsEnum = PermissionsEnum;
  public workOrderTab = WorkOrderMenuItem.Maintenance;
  public readingTab = ReadingsMenuTab.MeterReadings;
  public workOrderAllowed = false;
  isSidebarExpanded  = false;
  tooltipPos = { top: 0, left: 0 };
  showTooltip: boolean = false;
  tooltipText: string = '';
  items: any = [];
  utilityId: number = 0;

  get canSeeMeterStockInventory(): boolean {
    const p = this.permissionsService;
    return (p.hasDashboardConfigMeterCustomers && p.isCustomerMeterStockInventoryViewAllowed)
        || (p.hasDashboardConfigMeterAssets && p.isAssetMeterStockInventoryViewAllowed)
        || (p.hasDashboardConfigMeterCtvt && p.isCtvtMeterStockInventoryViewAllowed);
  }

  get canSeeMeterStockUtilization(): boolean {
    const p = this.permissionsService;
    return (p.hasDashboardConfigMeterCustomers && p.isCustomerMeterStockInventoryViewUtilizationStockAllowed)
        || (p.hasDashboardConfigMeterAssets && p.isAssetMeterStockInventoryViewUtilizationStockAllowed)
        || (p.hasDashboardConfigMeterCtvt && p.isCtvtMeterStockInventoryViewUtilizationStockAllowed);
  }

  get canSeeDecommissionedMeterStock(): boolean {
    return this.permissionsService.hasDashboardConfigMeterCustomers
        && this.permissionsService.isCustomerDecommissionedMeterStockViewAllowed;
  }

  get canSeeMeterManagementMenu(): boolean {
    return this.canSeeMeterStockInventory
        || this.canSeeMeterStockUtilization
        || this.canSeeDecommissionedMeterStock;
  }

  constructor(
    private authService: AuthService,
    public permissionsService: PermissionsService,
    public router: Router,
    private reportStateService: ReportStateService,
    private sidebarService: SidebarService,
    private substationTemplateService: SubstationTemplateService,
    private utilitySharedService: UtilitySharedService,
    private toastr: ToastrService,
    private translateService: TranslateService,
  ) {
    this.sidebarService.isSidebarExpanded$.subscribe((state) => {
      this.isSidebarExpanded = state;
    });
    this.utilityId = this.utilitySharedService.getUtilityId() ?? 0;
  }

  getSidebarSubstations(){
    if(this.utilityId === 0) return;
    this.substationTemplateService.getAllForSidebar(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        this.items = responseData ? responseData.data : [];
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading substation templates');
      },
    });
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  ngOnInit(): void {
    this.setWorkOrdersTabAndPermissions();
    this.getSidebarSubstations();
  }

  clearFilter(){
    localStorage.removeItem('filter');
    localStorage.removeItem('filterMeter');
    localStorage.removeItem('filterPole');
    localStorage.removeItem('filterTransformer');
    localStorage.removeItem('filterCustomer');
    localStorage.removeItem('filterBuilding');
    localStorage.removeItem('filterMvPole');
    localStorage.removeItem('filterPaymentHistory');
    localStorage.removeItem('filterServiceRequestOnboardedCustomers');
    localStorage.removeItem('filterServiceRequestAuthorization');
    localStorage.removeItem('filterSiteVerification');
    this.reportStateService.clearAllReportFilters({ clearMainTabSelection: true, clearDataQualityTabsSelection: true });
  }
  logout(){
    this.authService.logout(true);
    this.router.navigate(['']);
    this.resetColors();
  }
  resetColors(){
    document.documentElement.style.setProperty('--primary-color', '#03423E');
    document.documentElement.style.setProperty('--bg-color', '#F5FBFA');
    document.documentElement.style.setProperty('--table-root-bg-color', '#EBF1F1');
    document.documentElement.style.setProperty('--card-color', '#e4ecea');
    document.documentElement.style.setProperty('--bubble-color', '#688F8D');
  }

  setWorkOrdersTabAndPermissions() {
    this.workOrderAllowed = this.permissionsService.isSiteVerificationAllowed || this.permissionsService.isWorkOrderMaintenanceAllowed;
    if (this.permissionsService.isWorkOrderMaintenanceAllowed) {
      this.workOrderTab = WorkOrderMenuItem.Maintenance;
    }
  }

  onHoverItem(event: MouseEvent, text: string){
    if(!this.isSidebarExpanded) return;

    const navItem = (event.target as HTMLElement).closest('.nav-item') as HTMLElement;
    if (!navItem) return;

    const rect = navItem.getBoundingClientRect();

    this.tooltipPos = {
      top: rect.top + 2,
      left: rect.left + rect.width + 5,
    };
    this.tooltipText = this.translateService.instant(text);
    this.showTooltip = true;
  }

  onLeave() {
    this.showTooltip = false;
  }
}

